import {
  MainAudioTag,
  MethodsFireRequest,
  ModeCreativeEnum,
  messageType as messageTypeEnum,
  nodeActionTypes,
  nodeTriggerTypes,
  nodeTypeSettings,
  sendMethodEnum,
} from 'consts/data';
import { isDefine, removeNullOfObject } from 'helpers';
import { cloneDeep, get, isArray, isEmpty, isPlainObject, set } from 'lodash';
import MediaModel from './media.model';
import CampaignModel from './campaign.model';
import URLBuilderService from 'services/URLBuilderService';

let id = 0;
const keyNode = `dndnode`;

export const genIdNode = (idAvailable) => {
  if (isDefine(idAvailable)) {
    return `${keyNode}_${idAvailable}`;
  }

  return `${keyNode}_${id++}`;
};

const genShapeNode = () => {
  return {
    id: '',
    dragging: false,
    selected: false,
    type: 'customnode',
    idNodeInner: '',

    width: 268,
    height: 210,
    position: { x: 152, y: 90 },
    data: {
      label: '',
      type: 'customnode',
      triggerType: 'trigger',
      typeActions: 'inbound_message',
      inbound_message: {
        keywords: '',
        intents: '',
      },
      dtmf: {
        button: '',
      },
      send_message: {
        messageType: '',
        impressionUrl: '',
        creative: '',
        offer: '',
        medias: [],
      },
      fire_request: {
        webhook: '',
      },
      forward_call: {
        phone: '',
      },
      play_audio: {
        media: '',
      },
      send_voice: {
        media: '',
        impressionUrl: '',
        messageType: 'VOICE',
      },
    },
  };
};

const genShapeEdge = () => {
  return {
    id: 'reactflow__edge-dndnode_111:action-dndnode_138:trigger',
    source: 'dndnode_111:action',
    sourceHandle: null,
    target: 'dndnode_138:trigger',
    targetHandle: null,
    idEdgeInner: null,
    actionId: '',
    triggerId: '',
    type: 'custom',
  };
};

/**
 *
 * @param {Object} node
 * @param {{ label: string, type: string, triggerType: string }} node.data
 * @param {string} node.id
 * @param {number} node.height
 * @param {number} node.width
 * @param {string} node.typeActions
 * @param {{ x: number, y: number}} node.position
 * @returns
 */
const collectSummaryNode = (node) => {
  const nextNode = cloneDeep(node);
  //* id / idNodeInner -> from initiateNodeEdges
  //* idDnD / idNodeInner will be remove when call API. Everything else will be put to request

  const { typeActions, data } = nextNode;
  const body = data?.[typeActions] || {};

  const { order } = body;

  const result = {
    idDnD: nextNode.id,
    idNodeInner: nextNode.idNodeInner,

    type: nextNode.typeActions,
    // delayedMinute: isNumeric(nextNode?.data[nextNode.typeActions]?.delayedMinute)
    //   ? Number(nextNode?.data[nextNode.typeActions]?.delayedMinute)
    //   : '',
    position: {
      x: nextNode?.position?.x,
      y: nextNode?.position?.y,
      width: nextNode.width,
      height: nextNode.height,
      order,
    },
  };

  const uuid = get(nextNode, 'data.stats.uuid');

  if (uuid) {
    result.uuid = uuid;
  }

  return result;
};

//* Use for future
const commonSettings = (node) => {
  const result = {};

  return result;
};

/**
 * Check nodeProperties / initiateNodeEdges / parseTriggersAndActions
 */

//! Model
class ResponderV2Model {
  constructor() {
    this.responder = {};
    this.actionType = {};
    this.triggerType = {};
    this.responderForwardPhones = [];
    this.simulation = {
      hasInboundCall: false,
    };
  }

  set(key, value) {
    set(this, key, value);
  }

  findNode(id) {
    let result = undefined;

    const recursive = (nodes) => {
      for (let node of nodes || []) {
        if (`${id}` === `${node.id}`) {
          result = node;
          break;
        }

        if (isArray(node.children) && node.children.length > 0) {
          recursive(node.children);
        }
      }
    };

    recursive(get(this.responder, 'nodes') || []);
    console.log('Node found: ', result);
    return result;
  }

  //* Public functions
  static shouldConnect({ typeTrigger, typeAction }) {
    const pool = ResponderV2Obj?.triggerType;
    const typesActionAllowed = get(pool, `${typeTrigger}.elements`) || [];
    if (typesActionAllowed.includes(typeAction)) {
      return true;
    }

    return false;
  }

  static mappingDescriptionActionOrTrigger({ isTrigger, type }) {
    return (
      get(
        isTrigger ? ResponderV2Obj.triggerType : ResponderV2Obj.actionType,
        `${type}.description`
      ) || type
    );
  }

  static parseSimulateBodyRequestCommon({ responderId, trigger } = {}) {
    return {
      responderId: responderId || ResponderV2Obj.responder.id,
      triggerType: trigger?.type,
      responderForwardPhones: isEmpty(ResponderV2Obj.responderForwardPhones)
        ? undefined
        : ResponderV2Obj.responderForwardPhones,
    };
  }

  static initialResponder(responder = {}, { isExcludeDeleteNode, isLoopBack } = {}) {
    const tempResponder = cloneDeep(responder);
    let nodes = tempResponder?.nodes || [];

    //* Remove item that deleted
    const recursiveFilterNodeDeleted = (nodes) => {
      const tempNodes = nodes.filter((el) => !el.deleted);

      tempNodes.forEach((node) => {
        if (isArray(node.children) && node.children.length > 0) {
          node.children = recursiveFilterNodeDeleted(node.children);
        }
      });

      return tempNodes;
    };

    //* Add responderId + label
    const recursiveGo = (list, name, level = 1) => {
      if (list === undefined) return;

      let tmp = 0;
      list.forEach((node) => {
        tmp++;
        const number = name + '.' + tmp.toString();
        const nameOfNode = `Node #${number}`;
        node.label = nameOfNode;
        node.responderId = responder?.id;
        node.level = level;

        if (node.children && typeof node.children === 'object') {
          recursiveGo(node.children, number, level + 1);
        }
      });
    };

    //* Check if node is final
    const recursiveFindAndMarkAsFinal = (list) => {
      if (!list || !isArray(list) || list.length <= 0) {
        return;
      }

      list.forEach((node) => {
        if (isArray(node.children)) {
          if (node.children <= 0) {
            node.isFinalNode = true;
          } else {
            recursiveFindAndMarkAsFinal(node.children);
          }
        }
      });
    };

    recursiveGo(nodes, 1, 1);

    if (isExcludeDeleteNode) {
      nodes = recursiveFilterNodeDeleted(nodes);
    }

    if (isLoopBack) {
      recursiveFindAndMarkAsFinal(nodes);
    }

    tempResponder.nodes = nodes;
    return tempResponder;
  }

  static parseActionVariables(actionVariable) {
    if (isPlainObject(actionVariable)) {
      const temp = [];

      Object.entries(actionVariable || {}).forEach((el) => {
        const nodeId = el?.[0];
        const actionIds = el?.[1];
        Object.entries(actionIds || {}).forEach((e) => {
          const actionId = e[0];
          const variable = e[1];
          temp.push({
            nodeId,
            actionId,
            variable,
          });
        });
      });

      return temp;
    }

    return [];
  }

  static getTypeOfNode(node) {
    return {
      isTrigger: node?.data?.triggerType === nodeTypeSettings.trigger,
      isAction: node?.data?.triggerType === nodeTypeSettings.action,
    };
  }

  static getIdSource(id = 'dndnode_145:action', type = 'action') {
    if (!id.includes(type)) {
      return undefined;
    }

    const result = id.split('_')[1].replaceAll(`:${type}`, '');
    if (result) {
      return Number(result);
    }

    return undefined;
  }

  static parseBodyToSaveResponder(values) {
    const tempValues = cloneDeep(values);
    const isUpdate = isDefine(tempValues?.id);

    const handleContactAndDIDGroups = (groups = [], type = 'contact') => {
      if (!isArray(groups)) {
        return [];
      }

      let tempGroups = cloneDeep(groups);
      if (type === 'contact') {
        tempGroups = tempGroups.map((g) => {
          return {
            contactGroupId: g?.id,
          };
        });
      }

      if (type === 'did') {
        tempGroups = tempGroups.map((g) => {
          return {
            didGroupId: g?.id,
          };
        });
      }

      if (!isUpdate) {
        tempGroups.forEach((el) => {
          delete el.responderId;
          delete el.id;
        });
      }

      return tempGroups;
    };

    const result = {
      id: isUpdate ? tempValues?.id : undefined,
      title: tempValues?.title,
      status: true,
      published: tempValues?.published,
      responderTemplate: tempValues?.responderTemplate || undefined,
      setting: tempValues?.setting || {
        enableSleep: false,
        enableLoopback: false,
        priority: 0,
      },
      contactGroups: handleContactAndDIDGroups(tempValues?.contactGroups, 'contact'),
      didGroups: handleContactAndDIDGroups(tempValues?.didGroups, 'did'),
    };

    return result;
  }

  static initialFilters(filters) {
    return {
      published: filters?.published,
      page: filters?.page || 0,
      size: filters?.size || 10,
      status: filters?.status || null,
      title: filters?.title || '',
      contactGroupIds: filters?.contactGroupIds || '',
      didGroupIds: filters?.didGroupIds || '',
    };
  }

  static initiateNodeEdges({ triggers, actions, triggerActions }) {
    const nodesTriggers = [];
    const nodeActions = [];
    const edges = [];

    //* Render each trigger node
    if (isArray(triggers)) {
      triggers.forEach((trigger, index) => {
        const shapeNode = genShapeNode();
        shapeNode.id = `${genIdNode(trigger.id)}:${nodeTypeSettings.trigger}`;
        shapeNode.data.triggerType = nodeTypeSettings.trigger;
        shapeNode.data.typeActions = trigger?.type;
        shapeNode.data.label = trigger.type;
        shapeNode.idNodeInner = trigger.id;

        const mapping = {
          [nodeTriggerTypes.voiceCommand]: {
            keywords: trigger?.triggerSetting?.keywords?.join(','),
          },
          [nodeTriggerTypes.inboundMessage]: {
            keywords: trigger?.triggerSetting?.keywords?.join(','),
            intents: trigger?.triggerSetting?.intents
              ?.map((el) => el.replaceAll('_', ' '))
              .join(','),
          },
          [nodeTriggerTypes.dtmf]: {
            button: trigger?.triggerSetting?.button || '',
          },
          [nodeTriggerTypes.noAnswer]: {
            timeout: trigger?.triggerSetting?.timeout,
          },
          [nodeTriggerTypes.noClick]: {
            timeout: trigger?.triggerSetting?.timeout,
          },
          [nodeTriggerTypes.noDtmf]: {
            timeout: trigger?.triggerSetting?.timeout,
          },
          [nodeTriggerTypes.noReplay]: {
            timeout: trigger?.triggerSetting?.timeout,
          },
        };

        shapeNode.data[trigger.type] = mapping?.[trigger.type];

        shapeNode.width = trigger?.position?.width || 200;
        shapeNode.height = trigger?.position?.height || 110;
        shapeNode.position = trigger?.position;

        shapeNode.data.stats = trigger;

        nodesTriggers.push(shapeNode);
      });
    }

    //* Render each action node
    if (isArray(actions)) {
      actions.forEach((action, index) => {
        const shapeNode = genShapeNode();
        shapeNode.id = `${genIdNode(action.id)}:${nodeTypeSettings.action}`;
        shapeNode.data.triggerType = nodeTypeSettings.action;
        shapeNode.data.typeActions = action?.type;
        shapeNode.data.label = action.type;
        shapeNode.idNodeInner = action.id;

        const { altRouteSetting } = action?.actionSetting || {};
        const { sendMethod, ani, routeId, routeName, didGroupId, didGroupName } =
          altRouteSetting || {};
        const isOneWay = Number(sendMethod) === sendMethodEnum.oneWay;
        const isTwoWays = Number(sendMethod) === sendMethodEnum.twoWays;

        //* Audio / Voice
        const audioBuilderSetting = get(action, 'actionSetting.audioBuilderSetting');
        const media = get(action, 'actionSetting.media') || {};

        const URLWebHooks = URLBuilderService.separateParamsWithHeaderFields(
          action?.actionSetting?.webhook
        );

        const modeCreative = () => {
          if (!isEmpty(action?.actionSetting?.responderCreativeAssistantSetting)) {
            return ModeCreativeEnum.aiCreative;
          }

          return ModeCreativeEnum.select;
        };

        const mapping = {
          [nodeActionTypes.AIAgent]: {
            creative: action?.actionSetting?.creative
              ? {
                  ...action?.actionSetting?.creative,
                  label: action?.actionSetting?.creative?.title,
                  value: action?.actionSetting?.creative?.id,
                }
              : '',
            groupUUID: action?.actionSetting?.groupUUID ?? '',
          },
          [nodeActionTypes.sendMessage]: {
            order: action?.position?.order,

            messageType: action?.actionSetting?.messageType,
            impressionUrl: action?.actionSetting?.impressionUrl,
            groupUUID: action?.actionSetting?.groupUUID ?? '',

            modeCreative: modeCreative(),
            creative: action?.actionSetting?.creative
              ? {
                  ...action?.actionSetting?.creative,
                  label: action?.actionSetting?.creative?.title,
                  value: action?.actionSetting?.creative?.id,
                }
              : '',
            creativeOnFly: '',
            responderCreativeAssistantSetting:
              action?.actionSetting?.responderCreativeAssistantSetting,

            offer: action?.actionSetting?.offer
              ? {
                  ...action?.actionSetting?.offer,
                  label: action?.actionSetting?.offer?.title,
                  value: action?.actionSetting?.offer?.id,
                }
              : '',
            medias: isArray(action?.actionSetting?.medias)
              ? action?.actionSetting?.medias.map((el) => ({ ...el, label: el.name, value: el.id }))
              : [],
            delayedMinute: action?.actionSetting?.delayedMinute ?? '',
            altRouteSetting: {
              sendMethod: Number(sendMethod) || null,
              ani: isOneWay ? ani : '',
              routeId: isOneWay
                ? {
                    label: routeName,
                    value: routeId,
                    id: routeId,
                  }
                : undefined,
              didGroupId: isTwoWays
                ? { label: didGroupName, value: didGroupId, id: didGroupId }
                : undefined,
            },
            optoutLink: isDefine(action?.actionSetting?.optoutLink?.id)
              ? {
                  label: action?.actionSetting?.optoutLink?.title,
                  value: action?.actionSetting?.optoutLink?.id,
                }
              : undefined,
          },
          [nodeActionTypes.fireRequest]: {
            order: action?.position?.order,

            webhook: URLWebHooks.url || '',
            paramsUrl: URLWebHooks.paramsUrl,
            method: action?.actionSetting?.method || '',
            delayedMinute: action?.delayedMinute || '',
            headers: action?.actionSetting?.headers?.map((el) => ({ ...el, key: el.name })) || [],
          },
          [nodeActionTypes.forwardCall]: {
            order: action?.position?.order,

            phone: action?.actionSetting?.phone || '',
            variable: action?.actionSetting?.variable || '',
            alternativeSip: action?.actionSetting?.alternativeSip || '',
            delayedMinute: action?.delayedMinute || '',
            groupUUID: action?.actionSetting?.groupUUID ?? '',
          },
          [nodeActionTypes.playAudio]: {
            order: action?.position?.order,

            mediaWithConfigs: MediaModel.initialMediaWithConfig({
              useConfigAudio: !!audioBuilderSetting,
              enableMediaGroup: !!audioBuilderSetting?.mediaGroup,

              tagsString: !!audioBuilderSetting
                ? CampaignModel.parseTagsStringFromResponse(audioBuilderSetting?.tagsString)
                : [{ id: 'tag-1', content: MainAudioTag, isFixed: true }],
              media: !audioBuilderSetting && {
                label: media?.name,
                value: media?.id,
              },
              mainAudioId: audioBuilderSetting?.media
                ? {
                    label: audioBuilderSetting?.media?.name,
                    value: audioBuilderSetting?.media?.id,
                  }
                : undefined,
              mediaGroupId: audioBuilderSetting?.mediaGroup
                ? {
                    label: audioBuilderSetting?.mediaGroup?.name,
                    value: audioBuilderSetting?.mediaGroup?.id,
                  }
                : undefined,
            }),
            delayedMinute: action?.delayedMinute || '',
            groupUUID: action?.actionSetting?.groupUUID ?? '',
          },
          [nodeActionTypes.sendVoice]: {
            order: action?.position?.order,

            mediaWithConfigs: MediaModel.initialMediaWithConfig({
              useConfigAudio: !!audioBuilderSetting,
              enableMediaGroup: !!audioBuilderSetting?.mediaGroup,

              tagsString: !!audioBuilderSetting
                ? CampaignModel.parseTagsStringFromResponse(audioBuilderSetting?.tagsString)
                : [{ id: 'tag-1', content: MainAudioTag, isFixed: true }],
              media: !audioBuilderSetting && {
                label: media?.name,
                value: media?.id,
              },
              mainAudioId: audioBuilderSetting?.media
                ? {
                    label: audioBuilderSetting?.media?.name,
                    value: audioBuilderSetting?.media?.id,
                  }
                : undefined,
              mediaGroupId: audioBuilderSetting?.mediaGroup
                ? {
                    label: audioBuilderSetting?.mediaGroup?.name,
                    value: audioBuilderSetting?.mediaGroup?.id,
                  }
                : undefined,
            }),
            impressionUrl: action?.actionSetting?.impressionUrl || '',
            messageType: action?.actionSetting?.messageType || messageTypeEnum.voice,
            delayedMinute: action?.actionSetting?.delayedMinute ?? '',
            groupUUID: action?.actionSetting?.groupUUID ?? '',

            altRouteSetting: {
              sendMethod: Number(sendMethod),
              didGroupId: isDefine(didGroupId)
                ? { label: didGroupName, value: didGroupId, id: didGroupId }
                : undefined,
            },
          },
        };

        shapeNode.data[action.type] = mapping?.[action.type] || {};

        shapeNode.width = action?.position?.width || 200;
        shapeNode.height = action?.position?.height || 110;
        shapeNode.position = action?.position;

        shapeNode.data.stats = action;

        nodeActions.push(shapeNode);
      });
    }

    if (isArray(triggerActions)) {
      triggerActions.forEach((edge) => {
        const nextEdge = genShapeEdge();
        nextEdge.id = `reactflow__edge-${genIdNode(edge.actionId)}:action-${genIdNode(
          edge.triggerId
        )}:trigger`;
        nextEdge.target = `${genIdNode(edge.triggerId)}:trigger`;
        nextEdge.source = `${genIdNode(edge.actionId)}:action`;
        nextEdge.idEdgeInner = edge.id;
        nextEdge.actionId = edge.actionId;
        nextEdge.triggerId = edge.triggerId;
        nextEdge.type = 'custom';

        edges.push(nextEdge);
      });
    }

    const nodes = [...nodesTriggers, ...nodeActions];
    console.log('initiate nodes', { nodes, edges });
    return { nodes, edges };
  }

  static initiatePopulateDataSetting(populateDataSetting) {
    if (isPlainObject(populateDataSetting)) {
      const result = {};

      Object.entries(populateDataSetting).forEach(([groupType, group]) => {
        set(result, `${groupType}`, { ...group, label: group?.groupName, value: group?.groupId });
      });

      return result;
    }

    return {};
  }

  static parseTriggersAndActions({ nodes } = { nodes: [] }) {
    let triggers = [];
    let actions = [];

    nodes.forEach((node) => {
      const { data } = node || {};
      const { typeActions, triggerType } = data || {};
      const isTrigger = triggerType === nodeTypeSettings.trigger;

      //* Example typeActions is inbound_message -> body node is data[inbound_message]
      const body = data[typeActions];

      //! Triggers
      const customMapTriggers = {
        [nodeTriggerTypes.voiceCommand]: () => {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
            triggerSetting: {
              ...commonSettings(node),
              keywords: (body?.keywords || '')
                .split(',')
                .map((el) => el?.trim())
                .filter((el) => !!el),
            },
          });
        },
        [nodeTriggerTypes.inboundMessage]: () => {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
            triggerSetting: {
              ...commonSettings(node),
              keywords: (body?.keywords || '')
                .split(',')
                .map((el) => el?.trim())
                .filter((el) => !!el),
              intents: (body?.intents || '')
                .split(',')
                .map((el) => el.trim())
                .filter((el) => !!el)
                .map((el) => {
                  return el.replaceAll(' ', '_');
                }),
            },
          });
        },
        [nodeTriggerTypes.dtmf]: () => {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
            triggerSetting: {
              ...commonSettings(node),
              button: get(body, 'button', ''),
            },
          });
        },
        [nodeTriggerTypes.noAnswer]: () => {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
            triggerSetting: {
              ...commonSettings(node),
              timeout: body?.timeout,
            },
          });
        },
        [nodeTriggerTypes.noClick]: () => {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
            triggerSetting: {
              ...commonSettings(node),
              timeout: body?.timeout,
            },
          });
        },
        [nodeTriggerTypes.noReplay]: () => {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
            triggerSetting: {
              ...commonSettings(node),
              timeout: body?.timeout,
            },
          });
        },
        [nodeTriggerTypes.noDtmf]: () => {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
            triggerSetting: {
              ...commonSettings(node),
              timeout: body?.timeout,
            },
          });
        },
      };

      //! Actions
      const customMapActions = {
        [nodeActionTypes.AIAgent]: () => {
          const { creative } = body || {};
          const tempBody = {
            ...collectSummaryNode({ ...node, typeActions }),
            actionSetting: {
              ...commonSettings(node),
              groupUUID: body?.groupUUID,
              creative: { id: creative?.value },
            },
          };

          actions.push(tempBody);
        },

        [nodeActionTypes.sendMessage]: () => {
          const {
            altRouteSetting,
            modeCreative,
            creative,
            creativeOnFly,
            responderCreativeAssistantSetting,
          } = body || {};
          const { sendMethod, ani, routeId, didGroupId } = altRouteSetting;

          const isOneWay = Number(sendMethod) === sendMethodEnum.oneWay;
          const isTwoWays = Number(sendMethod) === sendMethodEnum.twoWays;
          const isNotHasSendMethod = sendMethod === null;

          const isSupportVoice = [messageTypeEnum.mms, messageTypeEnum.mmse].includes(
            body?.messageType
          );

          const parseCreative = () => {
            let creativeReturn = undefined;

            if (modeCreative === ModeCreativeEnum.select && isDefine(creative?.value)) {
              creativeReturn = {
                id: creative?.value,
              };
            }

            if (modeCreative === ModeCreativeEnum.onFly && !!creativeOnFly) {
              creativeReturn = {
                message: creativeOnFly,
              };
            }

            return creativeReturn;
          };

          const tempBody = {
            ...collectSummaryNode({ ...node, typeActions }),
            actionSetting: {
              ...commonSettings(node),
              messageType: body?.messageType,
              impressionUrl: body?.impressionUrl,
              creative: parseCreative(),
              responderCreativeAssistantSetting:
                modeCreative === ModeCreativeEnum.aiCreative
                  ? responderCreativeAssistantSetting
                  : null,

              offer: isDefine(body?.offer?.id)
                ? {
                    id: body?.offer?.id,
                  }
                : undefined,
              medias: !isSupportVoice
                ? []
                : body?.medias?.map((el) => ({ id: el?.id, name: el?.name })) || [],

              altRouteSetting: {
                sendMethod: sendMethod,
                ani: isOneWay ? ani : undefined,
                routeId: isOneWay ? routeId?.value : undefined,
                didGroupId: isTwoWays ? didGroupId?.value : undefined,
              },

              delayedMinute: body?.delayedMinute ?? '',
              groupUUID: body?.groupUUID,
              optoutLink: body?.optoutLink
                ? {
                    id: body?.optoutLink?.value,
                  }
                : undefined,
            },
          };

          if (isNotHasSendMethod) {
            delete tempBody?.actionSetting?.altRouteSetting;
          }

          actions.push(tempBody);
        },
        [nodeActionTypes.fireRequest]: () => {
          actions.push({
            ...collectSummaryNode({ ...node, typeActions }),
            actionSetting: {
              ...commonSettings(node),
              webhook: URLBuilderService.concatURL(body?.webhook, body?.paramsUrl || []),
              method: body?.method,
              headers: isArray(body?.headers)
                ? body?.headers
                    ?.filter((el) => !!el.key)
                    .map((el) => ({ name: el?.key?.trim(), value: el?.value?.trim() }))
                : [],
            },
          });
        },
        [nodeActionTypes.forwardCall]: () => {
          actions.push({
            ...collectSummaryNode({ ...node, typeActions }),
            actionSetting: {
              ...commonSettings(node),
              phone: body?.phone || '',
              variable: body?.variable || '',
              alternativeSip: body?.alternativeSip || '',
              groupUUID: body?.groupUUID,
            },
          });
        },
        [nodeActionTypes.playAudio]: () => {
          const { useConfigAudio, media, audioBuilderSetting } =
            MediaModel.parseBodyRequestForMediaWithConfigs(body?.mediaWithConfigs);

          actions.push({
            ...collectSummaryNode({ ...node, typeActions }),
            actionSetting: {
              ...commonSettings(node),
              media: useConfigAudio
                ? undefined
                : {
                    id: media?.value,
                  },
              audioBuilderSetting: useConfigAudio ? audioBuilderSetting : undefined,
              groupUUID: body?.groupUUID,
            },
          });
        },

        [nodeActionTypes.sendVoice]: () => {
          const { didGroupId } = get(body, 'altRouteSetting', {}) || {};
          const { useConfigAudio, media, audioBuilderSetting } =
            MediaModel.parseBodyRequestForMediaWithConfigs(body?.mediaWithConfigs);

          const isUserSelectDIDGroup = isDefine(didGroupId?.value);

          const tempBody = {
            ...collectSummaryNode({ ...node, typeActions }),
            actionSetting: {
              ...commonSettings(node),
              messageType: body?.messageType || '',
              impressionUrl: body?.impressionUrl || '',

              media: useConfigAudio
                ? undefined
                : {
                    id: media?.value,
                  },
              audioBuilderSetting: useConfigAudio ? audioBuilderSetting : undefined,

              altRouteSetting: {
                sendMethod: 2,
                didGroupId: isUserSelectDIDGroup ? didGroupId?.value : undefined,
              },
              delayedMinute: body?.delayedMinute ?? '',
              groupUUID: body?.groupUUID,
            },
          };

          if (!isUserSelectDIDGroup) {
            delete tempBody?.actionSetting?.altRouteSetting;
          }

          actions.push(tempBody);
        },
      };

      if (isTrigger) {
        //* For dynamic type - some case must be custom
        if (customMapTriggers?.[typeActions]) {
          customMapTriggers?.[typeActions]();
        } else {
          triggers.push({
            ...collectSummaryNode({ ...node, typeActions }),
          });
        }
      } else {
        //* For dynamic type - some case must be custom
        if (customMapActions?.[typeActions]) {
          customMapActions?.[typeActions]();
        } else {
          actions.push({
            ...collectSummaryNode({ ...node, typeActions }),
          });
        }
      }
    });

    const result = {
      triggers,
      actions,
    };

    return result;
  }

  static parseEdges({ edges, nodeId } = { edges: [], nodeId: '' }) {
    const triggerActions = [];

    if (!isDefine(nodeId)) {
      return [];
    }

    edges.forEach((el) => {
      const { actionId, triggerId } = el;

      const pairConnection = {
        triggerId: triggerId,
        actionId: actionId,
        nodeId: nodeId,
        id: el.idEdgeInner,
      };

      if (!isDefine(el.idEdgeInner)) {
        delete pairConnection.id;
      }

      triggerActions.push(pairConnection);
    });

    return triggerActions;
  }

  static parsePopulateDataSetting(populateGroups) {
    if (isPlainObject(populateGroups)) {
      const result = {};
      Object.entries(removeNullOfObject(populateGroups)).forEach(([groupType, group]) => {
        set(result, `${groupType}.groupId`, group?.value || group?.id);
      });

      return result;
    }

    return {};
  }

  static nodeProperties(nodeProperties) {
    //* Mapping from initiateNodeEdges function
    if (nodeProperties) {
      return nodeProperties;
    }

    return {
      // Trigger types
      [nodeTriggerTypes.voiceCommand]: {
        keywords: '',
      },
      [nodeTriggerTypes.AMD]: {},
      [nodeTriggerTypes.inboundMessage]: {
        keywords: '',
        intents: '',
      },
      [nodeTriggerTypes.dtmf]: {
        button: '',
      },
      [nodeTriggerTypes.noAnswer]: {
        timeout: 1,
      },
      [nodeTriggerTypes.noClick]: {
        timeout: 1,
      },
      [nodeTriggerTypes.noDtmf]: {
        timeout: 1,
      },
      [nodeTriggerTypes.noReplay]: {
        timeout: 1,
      },

      // Action types
      [nodeActionTypes.AIAgent]: {
        creative: '',
        groupUUID: '',
      },

      [nodeActionTypes.sendMessage]: {
        order: undefined,
        messageType: '',
        impressionUrl: '',

        modeCreative: ModeCreativeEnum.select,
        creative: '',
        creativeOnFly: '',
        responderCreativeAssistantSetting: null,

        offer: '',
        medias: [],
        delayedMinute: '',
        groupUUID: '',
        optoutLink: undefined,

        altRouteSetting: {
          sendMethod: null,
          ani: '',
          routeId: '',
          didGroupId: '',
        },
      },
      [nodeActionTypes.fireRequest]: {
        order: undefined,

        webhook: '',
        paramsUrl: [],
        delayedMinute: '',
        method: MethodsFireRequest.GET,
        headers: [],
      },
      [nodeActionTypes.forwardCall]: {
        order: undefined,

        phone: '',
        variable: '',
        delayedMinute: '',
        alternativeSip: '',
        groupUUID: '',
      },
      [nodeActionTypes.playAudio]: {
        order: undefined,

        delayedMinute: '',
        mediaWithConfigs: MediaModel.initialMediaWithConfig(),
        groupUUID: '',
      },
      [nodeActionTypes.sendVoice]: {
        order: undefined,

        mediaWithConfigs: MediaModel.initialMediaWithConfig(),
        impressionUrl: '',
        messageType: messageTypeEnum.voice,
        delayedMinute: '',
        groupUUID: '',
        altRouteSetting: {
          sendMethod: 2,
          ani: '',
          didGroupId: '',
        },
      },
    };
  }

  static initialResponderOnfly(initialValues) {
    return {
      inboundForwardNumber: initialValues?.inboundForwardNumber || '',
      outboundForwardNumber: initialValues?.outboundForwardNumber || '',
      inboundMediaWithConfigs:
        initialValues?.inboundMediaWithConfigs || MediaModel.initialMediaWithConfig(),
    };
  }

  static checkIsTriggerTypeMatchActionType({ actionType, triggerType }) {
    const actionTypeElements = get(ResponderV2Obj.actionType, `${actionType}.elements`) || [];
    return actionTypeElements.includes(triggerType);
  }
}

export const ResponderV2Obj = new ResponderV2Model();
export default ResponderV2Model;
